
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/[[...categories]]",
      function () {
        return require("private-next-pages/ai/[[...categories]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/[[...categories]]"])
      });
    }
  